<template>
    <modal @close="emit('close')" width="20rem">
        <template #header>Copy Chart Settings & Tools</template>
        <template #body>
            <div class="flex flex-col max-w-xs">
                <div class="w-full" v-if="!isFuture">
                    <input class="form-control" disabled type="text" :value="symbol">
                </div>
                <div class="w-full" v-if="isFuture">
                    <spinner v-if="dataLoading"></spinner>
                    <template v-else>
                        <label for="contract">Select a Contract:</label>
                        <select class="form-control" name="contract" v-model="contract" id="contract">
                            <option :value="contract.symbol" v-for="contract in contracts">
                                {{ contract.contractMonth }} {{ contract.contractYear }}
                            </option>
                        </select>
                    </template>
                </div>
                <div class="w-full mt-2">
                    <label for="period">Select a Period:</label>
                    <select v-model="aggregation" class="form-control" name="aggregation" id="aggregation">
                        <option v-for="aggregation in aggregations" :value="aggregation.value">
                            {{ aggregation.label }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="max-w-xs italic text-sm mt-3 text-gray-700">
                Copying settings will overwrite any tools and settings you currently have saved.
            </div>
        </template>
        <template #footer>
            <div class="flex justify-center" v-if="!dataLoading">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="emit('close')">Cancel</div>
                <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="copy">Copy Chart</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
    symbol: {
        type: String,
        required: true
    },
    section: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['close']);

const isFuture = computed(() => {
    return props.section === 'futures';
});

const allAggregations = [
    {label: 'Intraday', value: {period: 'intraday', spec: 'contract'}},
    {label: 'Daily', value: {period: 'daily', spec: 'contract'}},
    {label: 'Daily Nearby', value: {period: 'daily', spec: 'nearby'}},
    {label: 'Weekly', value: {period: 'weekly', spec: 'contract'}},
    {label: 'Weekly Nearby', value: {period: 'weekly', spec: 'nearby'}},
    {label: 'Monthly', value: {period: 'monthly', spec: 'contract'}},
    {label: 'Monthly Nearby', value: {period: 'monthly', spec: 'nearby'}},
];

const contractAggregations = [
    {label: 'Intraday', value: {period: 'intraday', spec: 'contract'}},
    {label: 'Daily', value: {period: 'daily', spec: 'contract'}},
    {label: 'Weekly', value: {period: 'weekly', spec: 'contract'}},
    {label: 'Monthly', value: {period: 'monthly', spec: 'contract'}},
];

const aggregation = ref({ period: 'daily', spec: 'contract' });
const aggregations = ref(props.section === 'futures' ?  allAggregations : contractAggregations);
const dataLoading = ref(props.section === 'futures');
const contracts = ref([]);
const contract = ref(null);

const copy = () => {
    emit('copy', {
        symbol: isFuture.value ? contract.value : props.symbol,
        aggregation: aggregation.value
    });
};

const getContracts = () => {
    const route = window.route('api.contracts-in-root');

    axios.post(route, {symbol: props.symbol})
        .then((response) => {
            contracts.value = response.data;
            contract.value = response.data[0].symbol;
        }).catch(error => {
            console.error(error);
        }).then(() => {
            dataLoading.value = false;
        });
};

onMounted(() => {
    if (isFuture.value) {
        getContracts();
    }
});
</script>